export type CategoryKey =
  | 'entertainment'
  | 'business'
  | 'media'
  | 'workplace'
  | 'internet'
  | 'food';

export interface CategoryMeta {
  key: CategoryKey;
  label: string;
  desc: string;
}

export const categories: CategoryMeta[] = [
  { key: 'entertainment', label: '综艺娱乐圈', desc: '台前幕后、录影棚见闻与制作内情' },
  { key: 'business', label: '商业品牌圈', desc: '品牌动向、渠道与供应链的隐秘细节' },
  { key: 'media', label: '媒体公关圈', desc: '选题、采访与公关幕后的运作逻辑' },
  { key: 'workplace', label: '职场人脉圈', desc: '大厂内部文化、晋升与人情冷暖' },
  { key: 'internet', label: '互联网创投', desc: '创业公司、融资与产品背后的真话' },
  { key: 'food', label: '餐饮服务圈', desc: '网红店、供应链与后厨的行业真相' },
];

export interface NewsItem {
  id: string;
  title: string;
  excerpt: string;
  category: CategoryKey;
  tag: string;
  time: string;
  reads: string;
  image: string;
  marker: string;
}

export const featureStories: NewsItem[] = [
  {
    id: 'f1',
    title: '片场十二小时：一位场务眼中的综艺录制“第三现场”',
    excerpt:
      '真正精彩的部分往往不在正片里。化妆间、备采区与候场走廊，才是情绪最真实的舞台。一位在综艺组打拼五年的场务，还原了那些镜头扫不到的瞬间。',
    category: 'entertainment',
    tag: '热 · 独家',
    time: '2026-09-06',
    reads: '128.6万',
    image:
      'https://readdy.ai/api/search-image?query=backstage%20of%20a%20television%20studio%20during%20a%20variety%20show%20recording%20night%2C%20warm%20amber%20practical%20lights%2C%20crew%20silhouettes%20in%20motion%2C%20light%20fog%2C%20cinematic%20editorial%20photography%2C%20dark%20rich%20tones%20with%20red%20accents%2C%20depth%20of%20field&width=1200&height=760&seq=feature-stage-01&orientation=landscape',
    marker: '圈内独家',
  },
  {
    id: 'f2',
    title: '一家区域网红连锁店爆火前夜：后厨与选址的拉扯',
    excerpt:
      '门头排队只是表象。真正决定一家店能走多远，往往藏在后厨动线与选址团队反复撕扯的会议记录里。',
    category: 'food',
    tag: '行业观察',
    time: '2026-09-06',
    reads: '86.3万',
    image:
      'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20of%20a%20bustling%20restaurant%20kitchen%20at%20evening%20rush%2C%20steam%20rising%2C%20chef%20hands%20in%20motion%2C%20warm%20dim%20lighting%2C%20editorial%20reportage%20photography%2C%20rich%20amber%20and%20crimson%20tones%2C%20slightly%20grainy%20cinematic%20feel&width=1200&height=760&seq=feature-food-02&orientation=landscape',
    marker: '圈内观察',
  },
  {
    id: 'f3',
    title: '“人设”是如何被一条采访提纲毁掉的：公关圈的自省',
    excerpt:
      '越是精心设计的人设，越经不起一次真诚的追问。几位资深公关人复盘那些翻车现场，发现祸根往往在采访提纲的第一个问题。',
    category: 'media',
    tag: '复盘专栏',
    time: '2026-09-05',
    reads: '74.2万',
    image:
      'https://readdy.ai/api/search-image?query=cluttered%20newsroom%20desk%20with%20press%20release%20documents%2C%20voice%20recorder%20and%20coffee%20at%20night%2C%20single%20warm%20desk%20lamp%2C%20reportage%20editorial%20photography%2C%20moody%20cinematic%20lighting%2C%20warm%20brown%20and%20red%20tones&width=1200&height=760&seq=feature-media-03&orientation=landscape',
    marker: '深度幕后',
  },
  {
    id: 'f4',
    title: '大厂晋升答辩前的那个深夜，他在工位哭了',
    excerpt:
      '很多人只看到述职台上十分钟的从容。凌晨两点半的园区路灯、改到第七版的数据看板，才是这条路的真实刻度。',
    category: 'workplace',
    tag: '真实故事',
    time: '2026-09-05',
    reads: '95.1万',
    image:
      'https://readdy.ai/api/search-image?query=empty%20late%20night%20modern%20office%20cubicle%20with%20desk%20lamp%20glow%20and%20monitor%20blueprint%2C%20lonely%20worker%20silhouette%20by%20window%20overlooking%20city%20lights%2C%20moody%20editorial%20photography%2C%20deep%20warm%20shadows%2C%20cinematic&width=1200&height=760&seq=feature-office-04&orientation=landscape',
    marker: '职场见闻',
  },
];

export const trendingNews: NewsItem[] = [
  {
    id: 't1',
    title: '录影棚里的“导演对讲机”：一档节目失控的十分钟',
    excerpt: '备采间里所有人屏住呼吸，只有对讲机里的电流声格外刺耳……',
    category: 'entertainment',
    tag: '独家爆料',
    time: '2026-09-06',
    reads: '42.8万',
    image:
      'https://readdy.ai/api/search-image?query=director%20monitor%20wall%20inside%20a%20television%20control%20room%2C%20multiple%20glowing%20screens%2C%20headset%20and%20walkie%20talkie%20on%20desk%2C%20moody%20warm%20editorial%20photography%2C%20dark%20amber%20tones&width=800&height=560&seq=trend-t1&orientation=landscape',
    marker: '独家',
  },
  {
    id: 't2',
    title: '连锁奶茶店的“半成品”生意经，老板亲述账本',
    excerpt: '把配方标准化到极致之后，真正赚钱的反而是供应链那一段……',
    category: 'food',
    tag: '行业内幕',
    time: '2026-09-06',
    reads: '36.5万',
    image:
      'https://readdy.ai/api/search-image?query=milk%20tea%20shop%20counter%20with%20ingredient%20containers%20and%20accounting%20ledger%20under%20warm%20lights%2C%20editorial%20photography%2C%20cozy%20amber%20mood&width=800&height=560&seq=trend-t2&orientation=landscape',
    marker: '行业内幕',
  },
  {
    id: 't3',
    title: '为什么发布会后的那顿“答谢饭”，比议程更关键',
    excerpt: '真正决定合作走向的对话，往往发生在饭桌上的第三个小时……',
    category: 'business',
    tag: '商务观察',
    time: '2026-09-05',
    reads: '31.2万',
    image:
      'https://readdy.ai/api/search-image?query=round%20dinner%20table%20after%20a%20business%20event%20with%20people%20in%20soft%20focus%20talking%2C%20warm%20candle%20like%20lighting%2C%20editorial%20photography%2C%20rich%20dark%20tones&width=800&height=560&seq=trend-t3&orientation=landscape',
    marker: '圈内观察',
  },
  {
    id: 't4',
    title: '从“被裁”到“猎头抢着要”，一场职场的自救复盘',
    excerpt: '一位前大厂员工，用三个月重新把自己送进了别人投不进的赛道……',
    category: 'workplace',
    tag: '真实故事',
    time: '2026-09-05',
    reads: '58.9万',
    image:
      'https://readdy.ai/api/search-image?query=professional%20at%20cafe%20typing%20on%20laptop%20with%20career%20notes%2C%20warm%20morning%20light%20through%20window%2C%20editorial%20photography%2C%20honest%20and%20hopeful%20mood&width=800&height=560&seq=trend-t4&orientation=landscape',
    marker: '职场见闻',
  },
];

export const categoryFeed: Record<CategoryKey, NewsItem[]> = {
  entertainment: [
    {
      id: 'e1',
      title: '彩排结束后，他独自把对手的失误默默补了十遍',
      excerpt: '台上台下早已习惯了失误前的“兜底”，却很少有人记得那个把兜底做成本能的人……',
      category: 'entertainment', tag: '幕后故事', time: '2026-09-06', reads: '22.4万',
      image: 'https://readdy.ai/api/search-image?query=dancer%20practicing%20alone%20on%20empty%20stage%20under%20single%20spotlight%2C%20moody%20editorial%20photography%2C%20warm%20amber%20light%2C%20cinematic&width=800&height=560&seq=cat-ent-e1&orientation=landscape',
      marker: '幕后',
    },
    {
      id: 'e2',
      title: '一档节目最花钱的地方，根本不在艺人片酬',
      excerpt: '外景车队、临时补妆间、凌晨的加餐——账目上每一条都在说话……',
      category: 'entertainment', tag: '行业账本', time: '2026-09-05', reads: '18.7万',
      image: 'https://readdy.ai/api/search-image?query=production%20crew%20loading%20equipment%20into%20van%20at%20dawn%20film%20location%2C%20documentary%20editorial%20photography%2C%20warm%20desaturated%20tones&width=800&height=560&seq=cat-ent-e2&orientation=landscape',
      marker: '行业',
    },
    {
      id: 'e3',
      title: '“后期小哥”的一天：他们替观众发现了所有穿帮',
      excerpt: '正片里的每一处完美，背后都是后期室整夜不灭的屏幕……',
      category: 'entertainment', tag: '职业图鉴', time: '2026-09-04', reads: '15.3万',
      image: 'https://readdy.ai/api/search-image?query=video%20editor%20working%20late%20at%20multiple%20screens%20with%20timeline%20software%2C%20dim%20room%20warm%20monitor%20glow%2C%20editorial%20photography&width=800&height=560&seq=cat-ent-e3&orientation=landscape',
      marker: '职业',
    },
  ],
  business: [
    {
      id: 'b1',
      title: '新消费品牌“退潮”之后，活下来的人做对了什么',
      excerpt: '当流量红利见顶，真正留下来的品牌开始重新研究货架、复购和现金流……',
      category: 'business', tag: '商业复盘', time: '2026-09-06', reads: '28.1万',
      image: 'https://readdy.ai/api/search-image?query=minimal%20retail%20shelves%20with%20facing%20packaging%20and%20hand%20adjusting%20products%2C%20warm%20store%20lighting%2C%20editorial%20commercial%20photography&width=800&height=560&seq=cat-biz-b1&orientation=landscape',
      marker: '复盘',
    },
    {
      id: 'b2',
      title: '渠道商没告诉你的“进场费”细则',
      excerpt: '谈了很久的进场条件，往往在合同最后一页还有一行小字……',
      category: 'business', tag: '行业潜规则', time: '2026-09-05', reads: '20.6万',
      image: 'https://readdy.ai/api/search-image?query=contract%20document%20and%20pen%20on%20boardroom%20table%20beside%20small%20product%20samples%2C%20warm%20moody%20editorial%20photography&width=800&height=560&seq=cat-biz-b2&orientation=landscape',
      marker: '潜规则',
    },
    {
      id: 'b3',
      title: '一碗面卖出三种价格：连锁加盟的定价玄机',
      excerpt: '同一碗面在不同门店的定价策略，背后是完整的选址分级逻辑……',
      category: 'business', tag: '定价揭秘', time: '2026-09-04', reads: '17.9万',
      image: 'https://readdy.ai/api/search-image?query=steaming%20noodle%20bowl%20on%20wooden%20counter%20with%20price%20tags%20blurred%2C%20warm%20appetizing%20editorial%20photography&width=800&height=560&seq=cat-biz-b3&orientation=landscape',
      marker: '揭秘',
    },
  ],
  media: [
    {
      id: 'm1',
      title: '一篇10万+背后，编辑部的三次“推倒重来”',
      excerpt: '好的内容从来不是一气呵成，而是反复推翻自己之后的必然……',
      category: 'media', tag: '内容幕后', time: '2026-09-06', reads: '19.4万',
      image: 'https://readdy.ai/api/search-image?query=editorial%20team%20gathered%20around%20table%20with%20printed%20drafts%20and%20sticky%20notes%2C%20warm%20office%20light%2C%20documentary%20style%20photography&width=800&height=560&seq=cat-med-m1&orientation=landscape',
      marker: '幕后',
    },
    {
      id: 'm2',
      title: '采访对象答应“开聊”的那顿饭，暗藏玄机',
      excerpt: '很多关键信息不在录音笔里，而在对方端起杯子那一刻的眼神里……',
      category: 'media', tag: '采访手记', time: '2026-09-05', reads: '13.8万',
      image: 'https://readdy.ai/api/search-image?query=reporter%20and%20guest%20in%20soft%20conversation%20at%20quiet%20restaurant%2C%20notebook%20on%20table%2C%20warm%20intimate%20lighting%2C%20editorial%20photography&width=800&height=560&seq=cat-med-m2&orientation=landscape',
      marker: '手记',
    },
  ],
  workplace: [
    {
      id: 'w1',
      title: '“向上管理”的尽头，其实是把事做好',
      excerpt: '有人把汇报练成了表演，而真正被记住的人，通常在关键时刻接住了球……',
      category: 'workplace', tag: '职场心得', time: '2026-09-06', reads: '33.2万',
      image: 'https://readdy.ai/api/search-image?query=young%20professional%20presenting%20to%20small%20group%20in%20bright%20meeting%20room%2C%20warm%20natural%20light%2C%20confident%20honest%20editorial%20photography&width=800&height=560&seq=cat-work-w1&orientation=landscape',
      marker: '心得',
    },
    {
      id: 'w2',
      title: '离职那天，她把三年来没说出口的话写进了交接文档',
      excerpt: '文字很平静，只有熟悉项目的人能读懂其中克制了多久……',
      category: 'workplace', tag: '真实故事', time: '2026-09-05', reads: '27.5万',
      image: 'https://readdy.ai/api/search-image?query=person%20packing%20personal%20belongings%20at%20desk%20near%20window%20in%20late%20afternoon%2C%20nostalgic%20warm%20light%2C%20documentary%20editorial%20photography&width=800&height=560&seq=cat-work-w2&orientation=landscape',
      marker: '故事',
    },
  ],
  internet: [
    {
      id: 'n1',
      title: '创业公司“烧钱”的那几年，账本是给谁看的',
      excerpt: '一轮轮融资之后，最诚实的往往不是愿景，而是每季度的现金曲线……',
      category: 'internet', tag: '创投观察', time: '2026-09-06', reads: '21.0万',
      image: 'https://readdy.ai/api/search-image?query=startup%20founder%20studying%20spreadsheet%20charts%20late%20at%20night%2C%20monitor%20glow%2C%20warm%20ambient%20light%2C%20editorial%20photography&width=800&height=560&seq=cat-net-n1&orientation=landscape',
      marker: '观察',
    },
    {
      id: 'n2',
      title: '产品上线前，用户研究团队最怕听到的一句“老板说”',
      excerpt: '很多功能死于开会，而活下来的那一个，往往赢在最初的用户访谈……',
      category: 'internet', tag: '产品幕后', time: '2026-09-05', reads: '14.6万',
      image: 'https://readdy.ai/api/search-image?query=user%20research%20interview%20session%20with%20notetaking%2C%20blank%20whiteboard%20in%20background%2C%20warm%20office%20light%2C%20honest%20documentary%20photography&width=800&height=560&seq=cat-net-n2&orientation=landscape',
      marker: '幕后',
    },
  ],
  food: [
    {
      id: 'g1',
      title: '网红店的“第二家分店”，为什么最容易亏',
      excerpt: '单店模型跑通后，扩张往往不是复制成功，而是暴露系统短板……',
      category: 'food', tag: '经营拆解', time: '2026-09-06', reads: '16.2万',
      image: 'https://readdy.ai/api/search-image?query=two%20restaurant%20storefronts%20one%20busy%20one%20quiet%2C%20evening%20street%2C%20warm%20sign%20lights%2C%20editorial%20city%20photography&width=800&height=560&seq=cat-food-g1&orientation=landscape',
      marker: '拆解',
    },
    {
      id: 'g2',
      title: '后厨老师傅不轻易外传的三条“省工”口诀',
      excerpt: '不是偷工减料，而是用经验和秩序，把忙碌的晚餐时段安排得井井有条……',
      category: 'food', tag: '后厨故事', time: '2026-09-04', reads: '12.9万',
      image: 'https://readdy.ai/api/search-image?query=experienced%20cook%20preparing%20ingredients%20in%20professional%20kitchen%2C%20steam%20and%20flames%2C%20warm%20dramatic%20lighting%2C%20editorial%20photography&width=800&height=560&seq=cat-food-g2&orientation=landscape',
      marker: '故事',
    },
  ],
};

export interface DeepDive {
  id: string;
  title: string;
  subtitle: string;
  body: string;
  image: string;
  stat: { num: string; label: string };
  category: string;
}

export const deepDives: DeepDive[] = [
  {
    id: 'd1',
    title: '一档观察类节目的“剧本感”争议',
    subtitle: '真实与编排之间，界线在哪里？',
    body: '当观众开始讨论“是不是演出来的”，节目的信任感就在悄悄流失。我们采访了参与制作不同环节的人，试图还原那条模糊的界线究竟在哪里，以及真诚为什么永远是最难复制的东西。',
    image: 'https://readdy.ai/api/search-image?query=stage%20directions%20script%20and%20clapperboard%20beside%20glowing%20studio%20lights%2C%20moody%20editorial%20photography%2C%20warm%20dramatic%20tones&width=900&height=660&seq=dive-d1&orientation=portrait',
    stat: { num: '28', label: '位访谈者' },
    category: '综艺观察',
  },
  {
    id: 'd2',
    title: '连锁餐饮扩张的“暗雷”：人、仓、钱',
    subtitle: '一家区域品牌用三年踩完的坑',
    body: '门店数量只是最表层的指标。真正考验扩张的，是能不能在同一时间把人的标准、仓的效率和钱的节奏全部对齐。这家品牌的管理者愿意把失败的路径也摊开来讲。',
    image: 'https://readdy.ai/api/search-image?query=aerial%20view%20of%20warehouse%20logistics%20with%20supply%20boxes%20and%20forklift%2C%20warm%20industrial%20lighting%2C%20editorial%20documentary%20photography&width=900&height=660&seq=dive-d2&orientation=portrait',
    stat: { num: '17', label: '家门店' },
    category: '餐饮经营',
  },
  {
    id: 'd3',
    title: '从实习到独立带项目：一次坦诚的复盘',
    subtitle: '关于那些简历上写不出来的成长',
    body: '成长不是线性上升，而是一连串接住又放下的时刻。一位从实习生一路做到独立负责项目的年轻人，分享了那些简历里写不出来、却真正改变他的瞬间。',
    image: 'https://readdy.ai/api/search-image?query=young%20person%20writing%20reflections%20in%20notebook%20by%20warm%20window%20light%20with%20city%20view%2C%20introspective%20editorial%20photography&width=900&height=660&seq=dive-d3&orientation=portrait',
    stat: { num: '5', label: '年跨度' },
    category: '职场成长',
  },
];

export interface Person {
  id: string;
  role: string;
  title: string;
  desc: string;
  image: string;
  tagline: string;
}

export const backstagePeople: Person[] = [
  {
    id: 'p1',
    role: '灯光师 · 从业12年',
    title: '“光会说话，只是很少有人听懂”',
    desc: '同一张脸在不同光位下是完全不同的情绪。在他看来，灯光是节目里最被低估的“第二演员”。',
    image: 'https://readdy.ai/api/search-image?query=lighting%20technician%20standing%20by%20studio%20lighting%20rig%20at%20night%2C%20warm%20backlit%20silhouette%2C%20editorial%20portrait%20photography%2C%20cinematic&width=640&height=760&seq=person-p1&orientation=portrait',
    tagline: '幕后人物',
  },
  {
    id: 'p2',
    role: '餐饮采购 · 从业9年',
    title: '“好味道的秘密，一半在凌晨的菜市场”',
    desc: '每天凌晨三点开工，他比任何人都先知道季节和行情，也最清楚什么涨价、什么以次充好。',
    image: 'https://readdy.ai/api/search-image?query=fresh%20produce%20buyer%20inspecting%20vegetables%20at%20dawn%20market%2C%20warm%20morning%20light%2C%20honest%20editorial%20portrait%20photography&width=640&height=760&seq=person-p2&orientation=portrait',
    tagline: '幕后人物',
  },
  {
    id: 'p3',
    role: '产品经理 · 从业7年',
    title: '“每一次克制加需求，都是在给用户省时间”',
    desc: '在他的工作清单里，删除一个功能往往比新增一个更难，也更重要。',
    image: 'https://readdy.ai/api/search-image?query=product%20manager%20at%20desk%20reviewing%20product%20sketches%20beside%20laptop%2C%20warm%20desk%20lamp%2C%20thoughtful%20editorial%20portrait%20photography&width=640&height=760&seq=person-p3&orientation=portrait',
    tagline: '幕后人物',
  },
];

export interface RankItem {
  id: string;
  title: string;
  category: CategoryKey;
  reads: string;
  trend: 'up' | 'flat' | 'down';
}

export const rankList: RankItem[] = [
  { id: 'r1', title: '为什么很多爆款都“不敢说真话”', category: 'media', reads: '128.6万', trend: 'up' },
  { id: 'r2', title: '大厂“向上管理”的真实边界在哪里', category: 'workplace', reads: '112.3万', trend: 'up' },
  { id: 'r3', title: '一家网红店垮掉的三种常见姿势', category: 'food', reads: '96.8万', trend: 'up' },
  { id: 'r4', title: '节目组最怕的，其实是“顺风顺水”', category: 'entertainment', reads: '88.4万', trend: 'flat' },
  { id: 'r5', title: '融资PPT里不会写的三行真话', category: 'internet', reads: '73.1万', trend: 'flat' },
  { id: 'r6', title: '被裁之后，他靠一条朋友圈回了职场', category: 'workplace', reads: '65.7万', trend: 'down' },
  { id: 'r7', title: '公关翻车，为什么总在周一早上', category: 'business', reads: '51.2万', trend: 'down' },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: '99爆料的稿子是怎么来的？来源可信吗？',
    a: '99爆料的线索主要来自圈内从业者的主动投稿，以及编辑部对公开信息与采访记录的交叉核验。我们坚持"信息可追溯、事实多源印证"的原则，重要内容在发布前会尽量找到第二位相关方进行确认，并对无法核实的信息做明确标注。',
  },
  {
    q: '如果我看到与自己相关的信息有误，该怎么办？',
    a: '你可以通过页面底部的"反馈与澄清"或"联系我们"入口提交说明，并附上相关依据。编辑部收到后会进行专项复核，若确属偏差，我们会尽快更正并在原内容处以显眼方式说明更新情况。',
  },
  {
    q: '如何向我投稿爆料？需要实名吗？',
    a: '你可以通过首页"我要投稿"表单提交线索，支持实名与匿名两种方式。为便于核实，我们建议你尽量描述事件的时间、地点与可交叉验证的细节；涉及隐私的内容我们默认做脱敏处理，不会在未经同意的情况下公开投稿人身份。',
  },
  {
    q: '匿名投稿的安全和隐私有保障吗？',
    a: '我们非常重视投稿人的隐私安全。匿名投稿会在系统与编辑部两个层面做信息隔离，除必要核实人员外不对外泄露投稿来源；对高风险内容，我们还会建议投稿人采用更谨慎的沟通方式。',
  },
  {
    q: '网站上分享的信息转载需要注意什么？',
    a: '99爆料的内容以观察与见闻为主，可能带有主观视角。如需引用或转载，请以原文链接为准，避免断章取义；涉及具体机构与个人的说法，请务必二次核实后再传播，以免以讹传讹。',
  },
  {
    q: '为什么有些文章会标注"待核实"或"行业观点"？',
    a: '圈内消息天然存在信息差。为保持诚实，我们对来源单一、尚未形成多源印证的内容会做出明确标注，将其定位为"行业观点"或"单方说法"，方便读者区分事实与观点，理性看待每一条信息。',
  },
];

export interface Testimonial {
  quote: string;
  name: string;
  role: string;
}

export const testimonials: Testimonial[] = [
  {
    quote: '信息密度很高，且很少出现为了流量刻意夸大的标题。编辑部对"待核实"的诚实标注，是我愿意持续追更的重要原因。',
    name: '林先生',
    role: '媒体从业者 · 订阅两年',
  },
  {
    quote: '作为圈内人，看到很多平时不好公开说的行业细节被认真记录，既意外又感激。这个平台把分寸感拿捏得不错。',
    name: '一位不愿具名的从业者',
    role: '综艺行业 · 深度用户',
  },
  {
    quote: '职场栏目尤其真实，很多故事就像发生在我同事身上。看得进去，也真的能学到东西。',
    name: '小周',
    role: '互联网员工 · 每日读者',
  },
];

export const seo = {
  siteName: '99爆料',
  tagline: '圈内人都在看的爆料入口',
  description:
    '99爆料专注圈内人脉消息，汇集内部人士、知情人士、工作人员透露的小道消息与行业观察。想了解台前幕后不为人知的一面，点开这里看圈内人都在传什么。',
};